import * as Immutable from "immutable"
import { VisualObject } from "./visualObject";

export abstract class Panel extends VisualObject {
      
  protected readonly BOXED = "boxed";
  
  get boxed(): boolean { return this.getInternalValue<boolean>(this.BOXED); }
  setBoxed(boxed: boolean): this { return this.setInternalValue(this.BOXED, boxed); }
}